"use client";

import { ChakraProvider } from "@chakra-ui/react";
import { ColorModeProvider, type ColorModeProviderProps } from "./ColorModeProvider";
import { system } from "@/theme/ChakraTheme";
import { Toaster } from "@/components/ui/toaster";

export function Provider({ children, ...props }: Readonly<ColorModeProviderProps>) {
    return (
        <ChakraProvider value={system}>
            <ColorModeProvider defaultTheme="light" {...props}>
                <Toaster />
                {children}
            </ColorModeProvider>
        </ChakraProvider>
    );
}
